import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../core/services/api/notification/notification.service';

@Injectable({ providedIn: 'root' })
export class NotificationShared {

  private notiSource = new BehaviorSubject<any[]>([]);
  notifications$ = this.notiSource.asObservable();

  constructor(
    private notificationSrv: NotificationService
  ) {}

  refreshNotifications() {
    this.notificationSrv.getNotificationAll().subscribe({
      next: (res) => {
        const data = res?.data;
        this.notiSource.next(data);
      },
      error: (err) => console.error('Error fetching noti', err)
    });
  }
}
